const o = ["#757F2F"], _ = [...o, "#C39618"], t = [..._, "#029FCF"], A = [..._, "#02A212", t[2]];
export {
  o as POI_7_TA1,
  _ as POI_7_TA2,
  t as POI_7_TA3,
  A as POI_7_TA4
};
//# sourceMappingURL=index.es5720.js.map
